<template>
  <div class="container">
    <!-- 顶部导航 -->
    <TopBar></TopBar>
    <div class="main">
      <div class="top-box">
        <div class="img">
          <img src="../../assets/better.png" class="icon" />
        </div>
        <div class="info">
          <div class="name">{{ zhaoData.jobs }}</div>
          <div class="classification">
            <span class="class-item">{{ zhaoData.jobsite }}</span>
            <span class="class-item">{{ zhaoData.cat_text }}</span>
            <span class="class-item">{{ zhaoData.title }}</span>
          </div>
          <div class="time">更新时间：{{ zhaoData.updatetime | getTime }}</div>
        </div>
        <div class="delivery">立即投递</div>
      </div>

      <!-- 招聘信息 -->
      <div class="main-info">
        <!-- 招聘信息 -->
        <div class="left-box">
          <div class="title">招聘简介</div>
          <div class="main-title">{{ zhaoData.jobs }}</div>

          <div class="line-box">
            <div class="line-title">一、公司简介</div>
            <p>
              中来股份成立于2008年，2014年上市(股票代码:SZ300393)总部坐落于江苏常熟，是一家专业从事太阳能技术产品研发与制造的国家级高新技术企业。2023年，中来股份成为浙江省能源集团有限公司(简称“浙能集团”)下属浙能电力的控股子公司。
            </p>
          </div>

          <div class="line-box">
            <div class="line-title">二、面向对象</div>
            <p>2024届应届生本科及以上</p>
          </div>

          <div class="line-box">
            <div class="line-title">三、热招城市</div>
            <p>上海、苏州</p>
          </div>

          <div class="line-box">
            <div class="line-title">四、热招岗位</div>
            <p>
              财经金融类、信息类、审计法务类、经济管理类、人力资源/管理类、供应雅类、市场营销类管培生
            </p>
          </div>

          <div class="line-box">
            <div class="line-title">五、投递渠道</div>
            <p>
              校招官网：https://cloud.jolywood.cn:9999/hrzp/#/schoolPosotionPhone
            </p>
          </div>
        </div>

        <div class="right-box">
          <div class="title">基本信息</div>
          <div class="info-item">
            <div class="title">网申开始：</div>
            <div class="value">2024-04-11</div>
          </div>

          <div class="info-item">
            <div class="title">网申截止：</div>
            <div class="value">暂无</div>
          </div>

          <div class="info-item">
            <div class="title">城市：</div>
            <div class="value">上海市，苏州市</div>
          </div>

          <div class="info-item">
            <div class="title">招聘岗位：</div>
            <div class="value">实习生，前台，销售</div>
          </div>

          <div class="info-item">
            <div class="title">专业要求：</div>
            <div class="value">无需求</div>
          </div>

          <div class="info-item">
            <div class="title">学历要求：</div>
            <div class="value">本科及以上</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部区域 -->
    <BottomBox></BottomBox>
  </div>
</template>

<script>
import TopBar from "../../components/TopBar/TopBar.vue";
import BottomBox from "../../components/BottomBox/BottomBox.vue";

import Home from "../../api/home.js";
import Utils from "@/common/utils.js";
export default {
  components: { TopBar, BottomBox },
  data() {
    return {
      listData: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 1,
        2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
      ],
      // listData: [1],
      industry: [],
      zhaoData: {},
    };
  },
  filters: {
    getTime(value) {
      console.log("时间", Utils.Getime(value));
      return Utils.Getime(value * 1000);
    },
  },
  async created() {
    let query = this.$route.query;
    console.log("接收的信息为", query);
    this.getZhaoData(query.id);
  },
  mounted() {},
  methods: {
    //获取招聘信息
    async getZhaoData(id) {
      let data = {
        zhaoid: id,
      };
      const result = await Home.GetZhaodate(data);
      this.zhaoData = result.data;
      console.log("招聘数据", result);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  margin-top: 68px;
  height: auto;
  // min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  background-color: #e9e9e9;
  .main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    min-width: 1000px;
    .top-box {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 10px;
      width: 50vw;
      height: 140px;
      background-color: #fff;
      border-radius: 10px;
      .img {
        margin-left: 20px;
        .icon {
          width: 90px;
          height: 90px;
        }
      }
      .info {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 90px;
        .name {
          font-size: 18px;
          font-weight: 600;
        }
        .classification {
          .class-item {
            display: inline-block;
            padding: 3px 5px;
            background-color: #f7f9fc;
            // background-color: green;
            border-radius: 10px;
            color: #9699a2;
            margin-right: 5px;
            font-size: 15px;
          }
        }
        .time {
          color: #9699a2;
          font-size: 15px;
        }
      }
      .delivery {
        position: absolute;
        right: 80px;
        padding: 10px 40px;
        border-radius: 20px;
        background-color: #f92b29;
        color: #fff;
        cursor: pointer;
      }
    }

    .main-info {
      display: flex;
      margin-top: 10px;
      width: 50vw;

      .left-box {
        border-radius: 10px;
        padding: 35px;
        box-sizing: border-box;
        width: 30vw;
        background-color: #fff;

        .title {
          font-size: 18px;
          font-weight: 600;
        }
        .main-title {
          text-align: center;
          font-weight: 600;
        }
        .line-box {
          margin-top: 20px;
          .line-title {
            font-weight: 600;
          }
        }
      }
      .right-box {
        border-radius: 10px;
        padding: 30px;
        box-sizing: border-box;
        background-color: #fff;
        margin-left: 20px;
        height: 250px;
        background: linear-gradient(180deg, #ffeff2, #fff 18%, #fff 0, #fff);
        flex: 1;
        .title {
          font-weight: 600;
          margin-bottom: 20px;
        }
        .info-item {
          display: flex;
          height: 25px;
          .title {
            font-size: 15px;
            font-weight: 500;
            color: #9699a2;
          }
          .value {
            font-size: 15px;
            font-weight: 500;
            color: #686969;
          }
        }
      }
    }
  }
}
</style>
